import revive_payload_client_4sVQNw7RlN from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/runner/work/trueblue-web/trueblue-web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/trueblue-web/trueblue-web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/trueblue-web/trueblue-web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import primevue_plugin_egKpok8Auk from "/home/runner/work/trueblue-web/trueblue-web/.nuxt/primevue-plugin.mjs";
import plugin_client_XxbS7tGyhp from "/home/runner/work/trueblue-web/trueblue-web/node_modules/@primevue/nuxt-module/dist/runtime/plugin.client.js";
import plugin_PSbK9A48ZQ from "/home/runner/work/trueblue-web/trueblue-web/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/runner/work/trueblue-web/trueblue-web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/home/runner/work/trueblue-web/trueblue-web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import auth_ANExhJHvcR from "/home/runner/work/trueblue-web/trueblue-web/plugins/auth.js";
import primevue_TdXjRgL1MA from "/home/runner/work/trueblue-web/trueblue-web/plugins/primevue.js";
import vueApp_ndfIPrzhjh from "/home/runner/work/trueblue-web/trueblue-web/plugins/vueApp.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  primevue_plugin_egKpok8Auk,
  plugin_client_XxbS7tGyhp,
  plugin_PSbK9A48ZQ,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  auth_ANExhJHvcR,
  primevue_TdXjRgL1MA,
  vueApp_ndfIPrzhjh
]